const SealIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clipPath="url(#clip0_957_7096)">
      <path
        d="M9.05742 0.575C8.47305 -0.00937501 7.52305 -0.00937501 6.93555 0.575L5.51367 2H3.49805C2.66992 2 1.99805 2.67188 1.99805 3.5V5.51562L0.573047 6.94063C-0.0113281 7.525 -0.0113281 8.475 0.573047 9.0625L1.99805 10.4844V12.5C1.99805 13.3281 2.66992 14 3.49805 14H5.51367L6.93867 15.425C7.52305 16.0094 8.47305 16.0094 9.06055 15.425L10.4824 14H12.498C13.3262 14 13.998 13.3281 13.998 12.5V10.4844L15.423 9.05937C16.0074 8.475 16.0074 7.525 15.423 6.9375L13.998 5.51562V3.5C13.998 2.67188 13.3262 2 12.498 2H10.4824L9.05742 0.575Z"
        fill="#0E9F6E"
      />
      <path
        d="M4.83398 8L6.83398 10L10.834 6"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_957_7096">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SealIcon;
